import * as R from 'ramda'
import { properties } from './entities'

export let ownerProperties = (state, ownerID) => R.values(R.filter(property => property.ownerID == ownerID, properties(state)))



// WEBPACK FOOTER //
// ./src/selectors/owner.js